import { render, staticRenderFns } from "./RentalCabinet.vue?vue&type=template&id=b7127fd0&"
import script from "./RentalCabinet.vue?vue&type=script&lang=js&"
export * from "./RentalCabinet.vue?vue&type=script&lang=js&"
import style0 from "./RentalCabinet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RentalCabinet.vue"
export default component.exports